import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { PagamentoResponseInterface } from '../../interfaces/curso/pagamento-response.interface';

@Injectable({
  providedIn: 'root'
})
export class GeraPagamentoService {

  _http = inject(HttpClient);

  geraPagamento(sigla: string, ofer: string, rg: string, tipo:string, pagador: string): Observable<PagamentoResponseInterface> {

    // Deverá enviar a sigla, oferecimento, RG, tipo do pagamento(2 para BOLETO, e 10 para CARTÃO) e por fim o PAGADOR.
    // return this._http.get<PagamentoResponseInterface>(environment.url + '/api/taxaInscricao/' + sigla + '/' + ofer + '/' + rg + '/' + tipo + '/' + pagador);
    return this._http.get<PagamentoResponseInterface>(environment.url + '/api/geraPagamento/' + sigla + '/' + ofer + '/' + rg + '/TAXA_INSCRICAO/' + tipo + '/' + pagador);
  }
}
